import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CerrixDialogInterface } from '../models/dialog/cerrix-dialog.model';

@Component({
    selector: 'cerrix-dialog',
    templateUrl: './cerrix-dialog.component.html',
    styleUrl: './cerrix-dialog.component.scss',
    imports: [
        MatDialogClose,
        MatButtonModule,
        MatIconModule,
        PortalModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CerrixDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<CerrixDialogComponent>>(MatDialogRef);
  public data = inject<CerrixDialogInterface>(MAT_DIALOG_DATA);

  @ViewChild('component', { read: ViewContainerRef }) component: any;
  @Input() public dataUiid: string = 'undefined';

  portalRef: ComponentPortal<any> | undefined;
  setMaxWidth: boolean = true;
  statusMessage: string | undefined;
  statusIcon: 'check_circle' | undefined;

  ngOnInit(): void {
    if (this.data.status !== undefined) {
      switch (this.data.status) {
        case 'success':
          this.statusMessage = 'Success';
          this.statusIcon = 'check_circle';
          break;
        case 'warning':
          this.statusMessage = 'Warning';
          this.statusIcon = 'check_circle';
          break;
        case 'error':
          this.statusMessage = 'Error';
          this.statusIcon = 'check_circle';
          break;
        default:
          break;
      }
    }
    if (this.data.maxWidth !== undefined) {
      this.setMaxWidth = this.data.maxWidth;
    }
    if (this.data.promptUiid !== undefined) {
      this.dataUiid = this.data.promptUiid;
    }

    this.createComponent();
  }

  createComponent(): void {
    this.portalRef = new ComponentPortal(this.data.component, this.component);
  }

  componentInit(componentRef: any) {
    if (componentRef !== null) {
      if (this.data.componentData) {
        Object.keys(this.data.componentData).forEach(input => {
          componentRef.instance[input] = this.data.componentData[input];
        });
      }

      // Tech debt: This piece code should be fixed and implemented later to automatically support EventEmitter.
      // Usage of these emitters
      // --------
      // var dialogRef = this._dialogService.openDialog({})
      // dialogRef.afterOpened().subscribe(() => {const subs = dialogRef.componentInstance[‘myEmitter’].subscribe(() => { <actions> }});
      // dialogRef.afterClosed().subscribe(() => subs.unsubscribe());
      // --------
      //
      // Object.keys(componentRef.instance)
      //   .filter(prop => componentRef.instance[prop] instanceof EventEmitter)
      //   .forEach(output => {
      //     this[output] = new EventEmitter()
      //     this[`${output}_sub`] = componentRef.instance[output].subscribe(data => {
      //       this[output].emit(data)
      //     })
      //     console.log(output);
      //   });
    }
  }

  close(actionFunction: () => boolean) {
    if (actionFunction()) {
      this.dialogRef.close();
    }
  }
}
